/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { keyframes } from '@emotion/react';
var breatheAnimation = keyframes({
  '0%': {
    opacity: 1
  },
  '50%': {
    opacity: 0.3
  },
  '100%': {
    opacity: 1
  }
});
var animatedStyles = css({
  animationName: breatheAnimation,
  animationDuration: '3.5s',
  animationTimingFunction: 'ease-in-out',
  animationIterationCount: 'infinite'
});
var baseStyles = css({
  overflow: 'hidden',
  opacity: 1,
  fontWeight: "var(--ds-font-weight-medium, 500)",
  color: "var(--ds-text-subtlest, #7A869A)",
  textAlign: 'center',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginBottom: '-1em',
  // Needs pixel precision to align the icon at the center of the box
  paddingBlock: "var(--ds-space-050, 4px)",
  paddingInline: "var(--ds-space-100, 8px)"
});
export var IconMessageWrapper = function IconMessageWrapper(props) {
  var animated = props.animated;
  return jsx("div", {
    id: "iconMessageWrapper",
    css: [baseStyles, animated && animatedStyles]
  }, props.children);
};